export const LockerDoorReservationSessionThingTypeMrn =
  "mrn:sl2:lockerDoorReservationSession";
